<!--
 @description dashBoard
 @author huangzhijie
 @date 2018/11/19
-->
<style>

</style>

<template>
  <div class="dashboard__content">
    <el-form ref="form" :model="form" :inline="true" input-width="auto">
      <el-form-item >
        <el-input v-model="form.name" prefix-icon="uk-icon-search" :placeholder="$t('common.search')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="e_add">{{ $t('common.add') }}</el-button>
      </el-form-item>
    </el-form>      

    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
  </div>
</template>
<script>
import dic from '@/components/mixins/dic'
import rac from '@/plugins/rac-mixin'
import table from '@/components/mixins/table'
import DashBoardBiz from '@/logic/intelligentMonitor/dashBoardBiz'
import { debounce, extend } from '@/utils/tool'

export default {
  mixins: [rac, dic, table],
  components: {
  },
  data () {
    const that = this
    return {
      inputTimer: null,
      doSearch: debounce(that.search, 500), // this is a curry function
      form: {
        name: ''
      },
      tableControl: [{
        label: that.$t('common.check'),
        callback: that.e_goDetail,
        rac: () => this.gRac('dashBoardSearch_detail')
      }, {
        label: that.$t('common.edit'),
        callback: that.e_goEdit,
        rac: () => this.gRac('dashBoardSearch_edit')
      }, {
        label: that.$t('common.delete'),
        callback: that.e_delete,
        rac: () => this.gRac('dashBoardSearch_delete')
      }]
    }
  },
  watch: {
    'form.name' (val) {
      this.tResetPage()
      this.doSearch(val)
    },
    $route (to, from) {
      if (to.name === 'dashBoard' && (from.name === 'handlerDashBoard' || from.name === '')) {
        this.search()
      }
    }
  },
  methods: {
    initTable () {
      this.tInitTable({
        lanKey: 'view.table',
        head: ['name'],
        requestFun: this.search
      })
    },
    search () {
      const reqData = extend(true, { ...this.tPageInfo }, this.form)
      DashBoardBiz.findBoard(reqData).then((data) => {
        this.tData = data
      })
    },
    e_add () {
      this.$router.push({ name: 'handlerDashBoard' })
    },
    e_goEdit (row, index, data) {
      const query = {
        id: row.id
      }

      this.$router.push({
        name: 'handlerDashBoard',
        query
      })

      // const query = {
      //   appName: row.extend.appName,
      //   group: row.extend.group,
      //   kpiKey: row.extend.kpiKey,
      //   viewId: row.id,
      //   type: row.type,
      //   dName: row.extend.name
      // }
      // if (row.param.series && typeof row.param.series === 'string') {
      //   query.series = row.param.series
      // }
      // this.$router.push({
      //   name: 'viewConfig',
      //   query
      // })
    },
    e_goDetail (row, index, data) {
      const query = {
        id: row.id
      }

      this.$router.push({
        name: 'dashBoardDetail',
        query
      })
    },
    e_delete (row, index, data) {
      this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
        type: 'warning'
      }).then(() => {
        DashBoardBiz.deleteBoard({
          id: row.id
        }).then((data) => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.search()
        })
      }).catch(() => {

      })
    }
  },
  mounted () {
    this.initTable()
    this.search()
  }
}
</script>
